import { combineReducers } from "redux";
import { configurationReducer } from "./configuration";
import { loaderReducer } from "./loader";
import { stepsReducer } from "./steps";
import { activeStepReducer } from "./activeStep";
import { btnStateReducer } from "./btnState";
import { dataSourceReducer } from "./dataSourceReducer";
import { returnedValueReducer } from "./returnedValueReducer";
import { setMessageReducer } from "./setMesageReducer";
import { reducer as formReducer } from "redux-form";
import { fetcherReducer } from "./fetcher";
import { itemBreadcrumbsReducer } from "./breadcrumbs";
import { alertDialogReducer } from "./alertDialog";
import { showFaqReducer } from "./showFaq";
import { faqReducer } from "./faq";
import { practitionerReducer } from "./practitioner";
import { cguReducer } from "./cgu";
import { showDialogSmsReducer } from "./showDialogSms";
import { userReducer } from "./user";
import { usersSelectedReducer } from "./usersSelected";
import { closeMainDialogReducer } from "./closeMainDialog";
import { RESET_APP } from "../actions/action-types";
import { codeSmsReducer } from "./codeSms";
import { showBtnNextReducer } from "./showBtnNext";
import { toValidateTokenReducer } from "./toValidateToken";
import { localeReducer } from "./localeReducer";
import { patientAreaReducer } from "./patientArea";
import { firstConnexionPatientAreaReducer } from "./firstConnexionPatientArea";
import { setMessageWithCodeReducer } from "./setMesageWithCodeReducer";
import { waitingRoomReducer } from "./waitingRoom";
import { externalPatientsQrCodeReducer } from "./externalPatientsQrCode";
import { userKeyReducer } from "./userKey";
import { secretReducer } from "./secret";
import { detailPatientReducer } from "./detailPatient";
import { paymentReducer } from "./payment";
import { isValidSocialSecurityReducer } from "./socialSecurity";
import { showCodePrioritaireReducer } from "./showCodePrioritaire";
import { dateSurveyReducer } from "./dateSurvey";
import { infoForStatusFormFieldReducer } from "./infoForStatusFormFieldReducer";
import { showFooterContinueReducer } from "./showFooterContinue";
import { paymentDetailsReducer } from "./paymentDetails";
import { appointmentUrlReducer } from "./appointmentUrl";

const appReducer = combineReducers({
  form: formReducer,
  configuration: configurationReducer,
  loader: loaderReducer,
  steps: stepsReducer,
  activeStep: activeStepReducer,
  btnState: btnStateReducer,
  dataSource: dataSourceReducer,
  returnedValue: returnedValueReducer,
  message: setMessageReducer,
  messageWithCode: setMessageWithCodeReducer,
  fetcher: fetcherReducer,
  itemBreadcrumbs: itemBreadcrumbsReducer,
  alertDialog: alertDialogReducer,
  showFaq: showFaqReducer,
  showDialogSms: showDialogSmsReducer,
  faq: faqReducer,
  cgu: cguReducer,
  practitioners: practitionerReducer,
  user: userReducer,
  usersSelected: usersSelectedReducer,
  mainDialog: closeMainDialogReducer,
  firstConnexionPatientArea: firstConnexionPatientAreaReducer,
  codeSms: codeSmsReducer,
  showBtnNext: showBtnNextReducer,
  toValidateToken: toValidateTokenReducer,
  locale: localeReducer,
  patientArea: patientAreaReducer,
  waitingRoom: waitingRoomReducer,
  externalPatientsQrCode: externalPatientsQrCodeReducer,
  userKey: userKeyReducer,
  secret: secretReducer,
  detailPatient: detailPatientReducer,
  payment: paymentReducer,
  socialSecurity: isValidSocialSecurityReducer,
  isShowCodePrioritaire: showCodePrioritaireReducer,
  dateSurvey: dateSurveyReducer,
  infoForStatusFormField: infoForStatusFormFieldReducer,
  showFooterContinue: showFooterContinueReducer,
  paymentDetails: paymentDetailsReducer,
  appointmentUrl: appointmentUrlReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === RESET_APP) {
    // only keep locale
    state = { locale: state.locale, user: state.user };
  }

  return appReducer(state, action);
};
